import { gql } from '@src/lib/gql'

export const CREATE_ADVISOR_CONNECT_ONBOARDING_LINK = gql`
  mutation CreateAdvisorConnectOnboardingLink($input: CreateAdvisorConnectOnboardingLinkInput!) {
    createAdvisorConnectOnboardingLink(input: $input) {
      url
      stripeConnectAccountId
      expiresAt
    }
  }
`
